import { UserMassUploadService } from './../../services/user-mass-upload.service';
import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { FormGroup, AbstractControl } from '@angular/forms';
import { ValidationMessages } from 'src/app/shared/enum/validation-messages.enum';
import { Roles } from 'src/assets/data/roles';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
  selector: 'invalid-user-detail',
  templateUrl: './invalid-user-detail.component.html',
  styleUrls: ['./invalid-user-detail.component.scss']
})
export class InvalidUserDetailComponent implements OnInit {
  @Input() user: any = {};
  @Input() id: string;

  constructor(private _userMassService: UserMassUploadService,
    private _flashMessageService: FlashMessageService,
    private _gaSvc: GoogleAnalyticsService,
    private currentUserService: CurrentUserService,
    private ref: ChangeDetectorRef) { }

  @Input() potentialMatches: any[] =  [];

  @Output() updated = new EventEmitter<any>();

  public loading: boolean;
  public panelOpenState: boolean;
  public userForm: FormGroup;
  public rolesDD = Roles;

  public emailValidationMessage = ValidationMessages.EXISTING_EMAIL;
  public emailValid;

  async ngOnInit() {
    this.userForm = this._userMassService.getUserForm(this.user, this.id);
  }

  /**
   * Check if given field is valid or not
   * @param field
   * @param parentField
   * @param index
   */
  public isValidField(field: string, duplicateCheck: boolean = false) {
    if (!field) return false;
    const control: AbstractControl = this.userForm.get(field);

    return duplicateCheck ? control.hasError('duplicateEmail') : control.hasError('required') || control.hasError('pattern') || control.hasError('existingUser') || control.hasError('duplicateEmail') || control.hasError('organizationCode');
  }

  public validateEmail(existingUser: boolean) {
    const control: AbstractControl = this.userForm.get('email');

    return existingUser ? control.hasError('existingUser') : control.hasError('duplicateEmail');
  }

  public getRoleDisplay(roleCode: string) {
    const role = Roles.find(role => role.value === roleCode);
    return role ? role.name : '';
  }

  /**
   * Update user info to temp collection for mass users
   */
  public updateChanges() {
    this._gaSvc.register('Mass Upload User', `Updated Invalid User.`, this.currentUserService.user.username);
    if (this.userForm.valid) {
      this.loading = true;

      this._userMassService.updateUser(this.userForm.value, this.id).subscribe(result => {
        this.updated.emit({});
        this.loading = false;
      }, () => {
        this._flashMessageService.updateMessage('Error occured while updating user.');
      });
    }
  }

}
